import { useApiResource } from '~/composables/api/useApiResource'

export const useNotificationApi = () => {
  const {
    loading,
    error,
    list,
    get,
    customEndpoint
  } = useApiResource('notifications', {
    deserialize: true,
    methods: {
      list: true,
      getById: true,
      create: false,
      update: false,
      delete: false
    }
  })

  const markAsReaded = customEndpoint((id) => ({
    url: `/notifications/${id}/readed`,
    method: 'PATCH'
  }))

  const markAllAsReaded = customEndpoint(() => ({
    url: '/notifications/readed',
    method: 'PATCH'
  }))

  const getUnreadedCount = customEndpoint(() => ({
    url: '/notifications/unreaded-count',
    method: 'GET',
    deserialize: false
  }))

  return {
    loading,
    error,
    list,
    get,
    markAsReaded,
    markAllAsReaded,
    getUnreadedCount
  }
}
